import { render } from "./schoolSafeResource.vue?vue&type=template&id=4ee77146&scoped=true"
import script from "./schoolSafeResource.vue?vue&type=script&lang=js"
export * from "./schoolSafeResource.vue?vue&type=script&lang=js"

import "./schoolSafeResource.vue?vue&type=style&index=0&id=4ee77146&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee77146"]])

export default __exports__